module.exports = __webpack_public_path__ + "img/setting-3.1c688508.png";